export default {
  map: null,
  distance: [],
  service: [],
  pos: [],
  posSelected: null,
  currentDistance: null,
  currentService: [],
  currentLatLng: null,
  markers: [],
};
